import { HttpClient } from '@angular/common/http';
// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "@angular/common/http";
import * as i3 from "NewAngular/services/core/urls.service";
export class SchwabSsoService {
    constructor(ajaxService, httpClient, urlsService) {
        this.ajaxService = ajaxService;
        this.httpClient = httpClient;
        this.urlsService = urlsService;
    }
    getSchwabSSOSaml() {
        return this.ajaxService.getDataObserveBody(this.urlsService.INTEGRATIONS.SCHWAB_SSO_SAML);
    }
}
SchwabSsoService.ɵfac = function SchwabSsoService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SchwabSsoService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.UrlsService)); };
SchwabSsoService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SchwabSsoService, factory: SchwabSsoService.ɵfac, providedIn: 'root' });
